import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = { class: "reset-password-page" }
const _hoisted_3 = { class: "account-manage inner" }
const _hoisted_4 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "password_heading_text" }
const _hoisted_7 = { class: "introduction" }
const _hoisted_8 = { class: "column" }
const _hoisted_9 = { for: "password-field" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "column" }
const _hoisted_12 = { for: "cpassword-field" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = {
  type: "submit",
  class: "buttonSubmit"
}
const _hoisted_15 = { key: 0 }

import { ref, onMounted, computed } from "vue";
import LanguageDropdown from "@/components/LanguageDropdown.vue";
import Logo from "@/components/logo.vue";
import { getLanguageList, getUserForResetPassword, passwordUpdate } from "@/services/api/auth";
import router from "@/router";
import SuccessMessage from "@/components/SuccessMessage.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  setup(__props) {

const device_language = navigator.language.replace("-", "_");
const password = ref("");
const cpassword = ref("");
const identifier = ref("");
const token = ref("");
const loading = ref(true);
const success = ref(false);
const errorMsgs = ref<string[]>([]);
const languageList = ref<any[]>([]);
const translate = ref<any[]>([]);
// const userLang = ref(device_language === "pt_BR" ? "PT" : "EN");
let userLang = ref("EN");
if (device_language === "pt_BR") {
	userLang.value = "PT";
} else if (device_language.toLowerCase() === "is" || device_language.toLowerCase() === "is_is" || device_language.startsWith("is")) {
	userLang.value = "IS";
}

const headingMessage = ref("reset_password_heading_message_text");

const handleLanguageChange = async (lang: string) => {
	userLang.value = lang;
	const storedData: any = localStorage.getItem("translate_text");
	const parsedData = JSON.parse(storedData);
	parsedData.userLang = lang;
	localStorage.setItem("translate_text", JSON.stringify(parsedData));
	localStorage.setItem("userLang", lang);
};

const init = async () => {
	const url = window.location.href;
	const match = url.match(/reset\/(.+)$/);
	const tokenFromUrl = match ? match[1] : null;

	if (!tokenFromUrl) {
		loading.value = false;
		return;
	}

	// Check localStorage success_res
	const storedSuccess = localStorage.getItem("success_res");
	if (storedSuccess) {
		try {
			const parsedSuccess = JSON.parse(storedSuccess);
			if (parsedSuccess?.hash && parsedSuccess.hash === tokenFromUrl) {
				// Token matches stored success hash, redirect immediately
				router.push("/reset/updated");
				return;
			}
		} catch (err) {
			console.error("Failed to parse success_res from localStorage:", err);
		}
	}

	// Token does not match or no stored success, proceed
	token.value = tokenFromUrl;
	await fetchLanguages();
	await fetchUser();
};


const fetchLanguages = async () => {
	try {
		const key = '75 - Reset Password UI';
		const res = await getLanguageList(key);
		languageList.value = res.languageList.length
			? res.languageList.filter((lang: any) => lang.key === "EN" || lang.key === "PT" || lang.key === "IS")
			: [];
		translate.value = res.translate || [];

		// Store the full language list + selected language + translation keys
		const headingObj = translate.value.find((item: any) => item.key === "updated_heading_message_text");
		const messageObj = translate.value.find((item: any) => item.key === "updated_message_text");

		const storedData = {
			languageList: languageList.value,
			updated_heading_message_text: headingObj || null,
			updated_message_text: messageObj || null,
		};

		localStorage.setItem("translate_text", JSON.stringify(storedData));
	} catch (err: any) {
		console.error("Failed to fetch language list:", err.message || err);
	}
};


const fetchUser = async () => {
	try {
		const res = await getUserForResetPassword(token.value);
		identifier.value = res?.identifier || "";
		localStorage.setItem("email_for_reset", identifier.value);
		localStorage.setItem("userLang", "EN");
	} catch (err: any) {
		console.error(err.response?.data || err.message);
	} finally {
		loading.value = false;
	}
};

// Translation helper
const translateText = (key: string, params: Record<string, string> = {}): string => {
	if (!translate.value || !Array.isArray(translate.value)) return key;

	const translationItem = translate.value.find((item) => item.key === key);
	if (!translationItem) return key;

	const userLangLower = userLang.value?.toLowerCase();
	const selectedLang = languageList.value.find(
		(lang) => lang.key?.toLowerCase() === userLangLower
	);
	const selectedLangId = selectedLang?._id;

	let translation: any;

	if (selectedLangId) {
		translation = translationItem.translate.find(
			(t: any) => t.languageId === selectedLangId && t.isPublished
		)?.value;
	}

	if (!translation) {
		const enLang = languageList.value.find((lang) => lang.key?.toLowerCase() === "en");
		const enLangId = enLang?._id;
		if (enLangId) {
			translation = translationItem.translate.find(
				(t: any) => t.languageId === enLangId && t.isPublished
			)?.value;
		}
	}

	if (!translation) translation = translationItem.base;

	if (translation && params) {
		Object.keys(params).forEach((k) => {
			const regex = new RegExp(`%this\\.user\\.${k}%`, "g");
			translation = translation.replace(regex, params[k]);
		});
	}

	return translation;
};


const introMsg = computed(() => {
	if (!token.value) {
		return "We cannot find a user matching this account. The token may have expired or be otherwise invalid.";
	}

	if (identifier.value && identifier.value.trim().length > 0) {
		const translationValue = translateText("intro_instruction_message_text", {
			identifier: identifier.value,
		});
		return translationValue || `Please reset the password for ${identifier.value}.`;
	}

	const translationValue = translateText("session_expire_text");
	return translationValue || "The link has expired, Please try again.";
});

const submitResetPassword = async () => {
	errorMsgs.value = [];
	success.value = false;
	const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/;
	const emojiRegex = /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF])/u;

	if (!password.value.trim() || !cpassword.value.trim()) {
		errorMsgs.value.push("enter_password_letter_validation_text");
	}

	if (
		password.value.trim() &&
		cpassword.value.trim() &&
		password.value !== cpassword.value
	) {
		errorMsgs.value.push("password_match_validation_text");
	}

	if (!regex.test(password.value)) {
		errorMsgs.value.push("password_letter_validation_text");
	}

	if (emojiRegex.test(password.value)) {
		errorMsgs.value.push("password_emoji_letter_validation");
	}

	if (!errorMsgs.value.length) {
		const payload = {
			password: password.value,
			token: token.value,
			email: identifier.value,
		};
		const res = await passwordUpdate(payload);
		if (res.valid) {
			success.value = true;

			localStorage.setItem(
				"success_res",
				JSON.stringify({
					hash: token.value,
					api_res: res,
				})
			);

			router.push("/reset/updated");
		}
		else {
			headingMessage.value = "reset_password_heading_message_text";
		}
	}
};

onMounted(() => {
	init();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Logo),
      _createVNode(LanguageDropdown, {
        languageList: languageList.value,
        defaultLang: _unref(userLang),
        onLanguageChanged: handleLanguageChange
      }, null, 8, ["languageList", "defaultLang"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "simple-spinner" }, null, -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("h1", _hoisted_6, _toDisplayString(translateText(headingMessage.value)), 1),
                _createElementVNode("p", _hoisted_7, _toDisplayString(translateText(introMsg.value)), 1),
                (identifier.value)
                  ? (_openBlock(), _createElementBlock("form", {
                      key: 0,
                      onSubmit: _withModifiers(submitResetPassword, ["prevent"])
                    }, [
                      _createElementVNode("p", _hoisted_8, [
                        _createElementVNode("label", _hoisted_9, _toDisplayString(translateText("form_new_password_text")), 1),
                        _withDirectives(_createElementVNode("input", {
                          id: "password-field",
                          type: "text",
                          class: "password-field",
                          placeholder: translateText('form_input_new_password_text'),
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event))
                        }, null, 8, _hoisted_10), [
                          [_vModelText, password.value]
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_11, [
                        _createElementVNode("label", _hoisted_12, _toDisplayString(translateText("form_confirm_password_text")), 1),
                        _withDirectives(_createElementVNode("input", {
                          id: "cpassword-field",
                          type: "text",
                          class: "password-field",
                          placeholder: translateText('form_input_confirm_password_text'),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((cpassword).value = $event))
                        }, null, 8, _hoisted_13), [
                          [_vModelText, cpassword.value]
                        ])
                      ]),
                      _createElementVNode("button", _hoisted_14, _toDisplayString(translateText("submit_label_text")), 1),
                      (errorMsgs.value.length)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errorMsgs.value, (msgKey, index) => {
                              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(translateText(msgKey)), 1))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 32))
                  : _createCommentVNode("", true)
              ])
            ]))
      ])
    ])
  ], 64))
}
}

})